export default __webpack_public_path__ + "static/media/homebuyer-search.93045b6d.jpg";